export const TURKISH_COFFEE_KITCHEN = 'turkish_coffee';

export function isTurkishCoffeeKitchen(kitchen) {
  return kitchen === TURKISH_COFFEE_KITCHEN;
}

export function isTurkishCoffeeItem(row) {
  return Boolean(row && isTurkishCoffeeKitchen(row.kitchen));
}
